import axios from "axios"

export const url = "https://api-super.com:8304/"

export const login = (data) => {
    return axios({
        method: "POST",
        url: url + "user/login",
        data
    })
}
export const checkSession = (data) => {
    return axios({
        method: "POST",
        url: url + "/user/session",
        data
    })
}

export const register = (data) => {
    return axios({
        method: "POST",
        url: url + "user/register",
        data
    })
}
export const saveImg = (data) => {
    return axios({
        method: "POST",
        url: url + "image/save",
        data
    })
}
export const getImg = (data) => {
    return axios({
        method: "POST",
        url: url + "image/get",
        data
    })
}